<div class="modal">
    <div class="content-strip">
        <h1>Delete Horse Profile</h1>
        <p>
            Are you sure you want to delete this horse? 
        </p>
        <p>
            This will remove the horse from your inventory, and all data associated with this horse will be removed.
        </p>
        <div class="button-container">
            <button
                mat-raised-button
                class="large-round go-back"
                (click)="goBack()"
                [disabled]="isDeleting$ | async"
            >
                No, Go Back
            </button>
            <button
                mat-button
                [disableRipple]="true"
                class="large-round end spinner"
                (click)="deleteHorse()"
                [disabled]="isDeleting$ | async"
            >
                Yes, Delete Profile
                <mat-icon *ngIf="isDeleting$ | async"><mat-spinner></mat-spinner></mat-icon> 
            </button>
        </div>
    </div>
</div>
